<template>
  <b-container class="my-4">
    <b-row>
      <b-col offset-md="2" md="8">
        <board />
        <rules class="mt-5" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import board from "./components/board.vue";
import rules from "./components/rules.vue"

export default {
  components: { board, rules },
  name: 'boardGamer',
};
</script>

<style scoped>

</style>
